const arAE = {
  locale: 'ar-AE',
  productsAddedToBasket: {
    one: '[de-DE] 1 product added to your basket',
    other: '[de-DE] {count} products added to your basket'
  },
  basketItems: {
    one: '[ar-AE] {count} item in your basket',
    two: '[ar-AE] {count} item in your basket',
    few: '[ar-AE] {count} item [few] in your basket',
    other: '[ar-AE] {count} items in your basket'
  },
  fakeStockItem: {
    one: '[ar-AE] 1 in stock on {date}',
    two: '[ar-AE] 2 in stock on {date}',
    few: '[ar-AE] {count} in stock on {date}',
    other: '[ar-AE] {count} in stock on {date}'
  },
  productStockInStock: {
    one: '[ar-AE] {count} in stock',
    two: '[ar-AE] {count} in stock',
    few: '[ar-AE] {count} in stock',
    other: '[ar-AE] {count} in stock'
  },
  productStockDueStock: {
    one: '[ar-AE] {count} due by {date}',
    two: '[ar-AE] {count} due by {date}',
    few: '[ar-AE] {count} due by {date}',
    other: '[ar-AE] {count} due by {date}'
  },
  searchProductDueStock: {
    one: '[ar-AE] Stock due {date}',
    two: '[ar-AE] Stock due {date}',
    few: '[ar-AE] Stock due {date}',
    other: '[ar-AE] Stock due on {date}'
  },
  filterViewResults: {
    one: '[ar-AE] View {count} Result',
    two: '[ar-AE] View {count} Results',
    few: '[ar-AE] View {count} Results',
    other: '[ar-AE] View {count} Result'
  },
  bulkBuyPack: {
    one: '[ar-AE] {count} pack',
    two: '[ar-AE] {count} pack',
    few: '[ar-AE] {count} pack',
    other: '[ar-AE] {count} pack'
  }
};

export default arAE;
